var $edb6b2fe456ed4e8$exports = {};
$edb6b2fe456ed4e8$exports = {
    "alpha": `Alfa`,
    "blue": `Modra`,
    "brightness": `Svetlost`,
    "green": `Zelena`,
    "hue": `Barva`,
    "lightness": `Lahkost`,
    "red": `Rde\u{10D}a`,
    "saturation": `Nasi\u{10D}enost`
};


export {$edb6b2fe456ed4e8$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
